import SettingConfig from '@module/config/setting';
import type { Site } from '@module/utils/site/hostname';
import { type FirebaseOptions, initializeApp } from 'firebase/app';

type Config = {
  [key in Site]:
    | false
    | {
        pushKey: string;
        config: FirebaseOptions;
        jsVer: string;
      };
};

const config: Config = {
  pandalive: {
    pushKey: 'BF1ak9Ph6gk19Mv9Zsw6tVpqnRvjKgpax7aQiZcJe6auFOQu2HyMbw_3Olq95FRM8WPaKz_dfj1--_g5VdSqY1M',
    config: {
      apiKey: 'AIzaSyCD7GHVhLbwWs2M0GUAzK3J1DEFQkKBKrE',
      projectId: 'fulltv-mobile',
      messagingSenderId: '360819823751',
      appId: '1:360819823751:web:d520b3cb8c6f6eae0e1422',
    },
    jsVer: 'e556c8130732e119ddc59ece4bc1acf7',
  },
  bktv: {
    pushKey: 'BHrDzgy1nJNThJhV9pGqmIgkCgR8ZRRRlaA0YBpF7gQ9MfycwGCJ0ismIS7ea2AZiyhSmws93a3PeOA_5_ic9sI',
    config: {
      apiKey: 'AIzaSyA1XRh2WGFlwSqPUuL0McNtJvk70KDgGgI',
      projectId: 'pandatest-eb1a9',
      messagingSenderId: '18101120075',
      appId: '1:18101120075:android:36f4d42a36983cdf93f1ce',
    },
    jsVer: 'e556c8130732e119ddc59ece4bc1acf7',
  },
};

const siteConfig = config[SettingConfig.CURRENT_SITE];
export const firebaseConfig = siteConfig === false ? null : siteConfig.config;
export const VAPID_PUBLIC_KEY = siteConfig === false ? null : siteConfig.pushKey;
export const app = firebaseConfig === null ? null : initializeApp(firebaseConfig);
